import './Card.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

export default function Card(props: {showIcon?: boolean, [key: string]: any}) {
    return <div className={'card-container hoverable ' + (props.className ? props.className : '')}>
        {props.showIcon ? <FontAwesomeIcon className='icon link-icon' icon={faArrowUpRightFromSquare}/> : null}
        {props.children}
    </div>;
};